import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { OPERATIONS, REDIRECT_URLS, WORK_STREAM_TYPE } from '../constants';
import { updateOperations } from '../redux/actionCreators/operations';
import { getNavigableOperations } from '../utils/operationFlow';

const useRedirectToNextScreen = () => {
	const { allowedOperations, currentOperation } = useSelector(
		(state) => state.operations,
	);
	const { workStreamType } = useSelector((state) => state.user);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const redirect = (
		callback,
		options = {
			paramId: null,
			useSameOperation: false,
			redirectUrl: '',
			operation: null,
		},
	) => {
		if (callback) callback();

		const navigableOperations = getNavigableOperations(allowedOperations);
		if (!navigableOperations.length) {
			return;
		}

		const normCurrent = currentOperation?.replace?.(/\s+/g, '_');
		const currentOperationIndex = navigableOperations.findIndex(
			(operation) => operation === currentOperation || operation === normCurrent,
		);

		let nextOperation;

		if (options.useSameOperation)
			nextOperation = navigableOperations[currentOperationIndex];
		else {
			// Find the next operation, skipping non-navigable operations.
			let nextIndex = (currentOperationIndex + 1) % navigableOperations.length;
			nextOperation = navigableOperations[nextIndex];
		}
		if (currentOperationIndex > -1) {
			const paramId = options.paramId ? `/${options.paramId}` : '';

			if (!Object.values(OPERATIONS).includes(nextOperation)) {
				if (
					navigableOperations[0] === OPERATIONS.DROP ||
					navigableOperations[0] === OPERATIONS.RECEIVE_SN
				) {
					if (workStreamType === WORK_STREAM_TYPE.POOL) navigate('/scan-vin');
					else navigate('/');
				} else {
					navigate(

						options.redirectUrl ||
						`${REDIRECT_URLS[navigableOperations[0]]}${paramId}`,
					);
				}
				dispatch(
					updateOperations({
						currentOperation: options.operation || navigableOperations[0],
					}),
				);
			} else {

				if (
					nextOperation === OPERATIONS.DROP ||
					nextOperation === OPERATIONS.RECEIVE_SN
				) {
					if (workStreamType === WORK_STREAM_TYPE.POOL) navigate('/scan-vin');
					else navigate('/');
				} else {
					navigate(
						options.redirectUrl ||
						`${REDIRECT_URLS[nextOperation]}${paramId}`,
					);
				}

				dispatch(
					updateOperations({
						currentOperation: options.operation || nextOperation,
					}),
				);
			}
		}
	};

	return redirect;
};

export default useRedirectToNextScreen;
